import QuotingServices from "../../services/QuotingServices";

const state = {
    loadingQuoting: false,
    cotizadores: []
};

const getters = {
    cotizadores: state => {
        return state.cotizadores;
    },
    loadingQuoting: state => {
        return state.loadingQuoting;
    }
};

const actions = {
    cotizadores(context) {
        context.commit("showLoadingIndicator");
        const profile = context.rootGetters.userProfile;
        const agencyId= context.rootGetters.agencyId;
        return QuotingServices.cotizadores(profile, agencyId)
            .then(res => {
                context.commit("cotizadores", res.data.data);
            })
            .finally(res => {
                context.commit("hideLoadingIndicator");
            });
    },

};

const mutations = {
    showLoadingIndicator(state) {
        state.loadingQuoting = true;
    },
    hideLoadingIndicator(state) {
        state.loadingQuoting = false;
    },
    cotizadores(state, cotizadores) {
        state.cotizadores = cotizadores.sort((a, b) => {
            return a.name > b.name;
        });
        state.loading = false;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};